export default __webpack_public_path__ + "static/madeira-madeira-19bc667da0bf87dd01f5bdb44c453e5c.jpg";